import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { base_url } from "../Api/Api";
import { Loader } from "../Common/Loader";
import Skeletoncnt from "./skeletonContent";
import Itemcoursskltn from "./courseItemSkltn";
import Comments from "../Common/Comments/Comments";

import Itemcours from "./Itemcours";

const Content = (props) => {
  const [state, setState] = useState({
    data: [],
    loader: true,
    statusContent: false,
    statusCourse: false,
  });
  const [hasLink, setHasLink] = useState(false);
  const [hasVideo, setHasVideo] = useState(false);
  const [linksList, setLinksList] = useState([]);

  useEffect(() => {
    if (props.match.params.pg !== undefined) {
      setState({
        ...state,
        data: [],
        statusContent: true,
        statusCourse: false,
      });

      base_url
        .get(
          `/${
            props.match.params.isHome === "home" ? "education-single" : "item"
          }/${props.match.params.pg}`,
          {

          }
        )
        .then((response) => {
          setState({
            ...state,
            data: response.data,
            statusContent: response.data.page_source.length == 0,
            statusCourse: response.data.courses.length == 0,
          });
          let C = document.getElementsByClassName("webview");
          let children = C[0].children;
          let list = [];
          for (var i = 0; i < children.length; i++) {
            if (children[i]) {
              if (children[i].childNodes[0]) {
                if (children[i].childNodes[0].attributes) {
                  if (children[i].childNodes[0].attributes.href) {
                    setHasLink(true);
                    list.push(children[i].childNodes[0].attributes);
                    //   // href.value
                    //   // title.value
                  } else if (children[i].childNodes[0].attributes.controls) {
                    setHasVideo(true);
                    document
                      .getElementsByTagName("video")[0]
                      .setAttribute("controlsList", "nodownload");
                  }
                }
              }
            }
          }
          setLinksList(list);
        })
        .catch((error) => {
          if (error.response != undefined) {
            if (error.response.status == 401) {
              props.history.push(`/Entrance`);
            }
          }
        });
    }
  }, [props.match.params.pg]);

  const openPdf = (e, href, title) => {
    localStorage.setItem("pdfLink", href);
    localStorage.setItem("pdfTitle", title);
    props.history.push(
      `/education/course-content/${props.match.params.id}/pdfViewer`
    );
  };
  return (
    <div className="content">
      <div className="row-detailes">
        <div className="breadcrumb">
          <h4>محتوای آموزشی</h4>
        </div>
        {state.data.length == 0 ? null : state.data.courses.length ==
          0 ? null : (
          <div className="btn-base btn-black btn-sircle btn-border-black">
            <a href="#courseEducation">
              <Button variant="contained">کرس درسی</Button>
            </a>
          </div>
        )}
      </div>

      <div className="content-education">
        {state.data.length == 0 ? (
          state.statusContent ? (
            <Skeletoncnt />
          ) : (
            <div className="no-content">
              <img src="/svg/Education.svg" />
              <span>
                جهت مشاهده محتوای آموزشی لطفا دسته بندی خود را انتخاب کنبد
              </span>
            </div>
          )
        ) : state.data.page_source.length == 0 ? (
          <div className="no-content">
            <img src="/svg/Education.svg" />
            <span>محتوای آموزشی در این دسته بندی قرار نگرفته است.</span>
          </div>
        ) : (
          <>
            <span className="score">
              <b>امتیاز این محتوا : </b>
              <i className="icon-black-star-silhouette"></i>
              {state.data.score}
            </span>
            <div
              id="htmlCodes"
              dangerouslySetInnerHTML={{ __html: state.data.page_source }}
            ></div>
            {hasLink && linksList.length ? (
              <div className="pdfs">
                {linksList.map((item, index) => (
                  <div className="pdf-item">
                    <button
                      className="btn pdf-btn"
                      id={index}
                      onClick={(e) =>
                        openPdf(e, item.href.value, item.title.value)
                      }
                    >
                      مشاهده {item.title.value}{" "}
                      <i className="icon-arrow-down-sign-to-navigate"></i>
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <></>
            )}
          </>
        )}
        <div className="tags-list tags all-styless">
          {state.data.length == 0
            ? null
            : state.data.tags.map((info) => (
                <span key={info.name}>{info.name}</span>
              ))}
        </div>
      </div>

      {state.data.length == 0 ? null : (
        <div className="courses-education" id="courseEducation">
          <h4>کرس درسی</h4>
          {state.data.courses.length !== 0 ? (
            state.data.courses.map((item) => (
              <Itemcours
                key={item.id}
                title={item.title}
                score={item.score}
                has_tutorial={item.has_tutorial}
                has_exam={item.has_exam}
                id={item.id}
                data={item}
                read={item.tutorials.map((tutorial) => {
                  return tutorial.read;
                })}
              />
            ))
          ) : state.statusCourse ? (
            <div className="no-content">
              <img src="/svg/copy.svg" />
              <span>فعلا کرسی برای این محتوای آموزشی ثبت نشده است</span>
            </div>
          ) : (
            <Itemcoursskltn />
          )}
        </div>
      )}
      {state.data.length == 0 ? null : state.data.page_source.length ==
        0 ? null : (
        <Comments
          id={state.data.item_id ? state.data.item_id : null}
          data={state.data}
          cmntPlaceholder="فعلا نظری برای این محتوای آموزشی ثبت نشده است"
        />
      )}
    </div>
  );
};

export default withRouter(Content);
